import { Component, OnInit, Input } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

import { File } from '@core/objects';
import { NotificationInterface } from '@core/store/models/notifications.interface';
import { FilesService }   from '@core/services/files/files.service';
import { NotificationsService } from '@core/services/notifications/notifications.service';
import { UrlService } from '@core/services/url/url.service';

@Component({
    selector: 'core-notifications-helpers-action-file-compression-start',
    templateUrl: './file-compression-start.component.html',
    styleUrls: ['./file-compression-start.component.scss']
})
export class CoreNotificationsHelpersActionFileCompressionStartComponent implements OnInit {

    // public readonly SUCCESS_DISPLAY_TIME = 10;
    
    // EVENT_VERSION_STATUS_UPDATED_SUCCESS
    @Input() notification: NotificationInterface;
    // @Output() dismiss = new EventEmitter<NotificationInterface>();

    // public time: number = this.SUCCESS_DISPLAY_TIME;
    // public countdown$: Observable<number> = interval(this.SUCCESS_DISPLAY_TIME);

    constructor(private notsSrv: NotificationsService, 
        private filesSrv: FilesService,
        private urlSrv: UrlService) {
    }

    ngOnInit(){
        console.log(" notification compression started ",this.notification);
        if(this.notification.data.details?.url){
            this.filesSrv.downloadCompressedFile(this.notification.data.details.url)
            .subscribe({
                next: (zipFile: File) => {
                    if(zipFile != null){
                
                        // const fileId = zipFile.id;
                        // Use the file id to change the location.href to download the file as usually
                        window.location.href = this.urlSrv.build('/files/'+zipFile.id);
                        this.dismiss();
                    } 
                },
                error: (err: HttpErrorResponse) => {
                    // TODO: Handle error maybe send a notification error.
                    console.debug(" download all files error ",err);
                    this.dismiss();
                }
            });
        
        }
        
    }

    dismiss():void {
        this.notsSrv.dismissNotification(this.notification.id);
    }


}
